import Router from "vue-router";
import { Vue } from "./CoreBase";
import { PageDefinition } from "../PageDefinition";

Vue.use(Router);

export const router = new Router({
	mode: 'history',
	routes: PageDefinition.getPageRoutes()
});